import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTemplateContext } from "../../../context/TemplateContext";
import { useTreeContext } from "../../../context/TreeDataContext";
import { getFolderFileById } from "../../../utils/treeData/folderEditorUtils";
import ErrorMessage from "../../../components/FormComponents/ErrorMessage";
import RdbmsTemplateViewer from "../RdbmsTemplateViewer/RdbmsTemplateViewer";
import Loader from "../../../Layouts/Loader/Loader";

const SqlTemplateCenterViewer = () => {
  const [isLoading, setIsLoading] = useState(true);

  const { sqlTemplateExplorerData } = useTreeContext();
  const {
    selectedTemplate,
    setSelectedTemplate
    // templateData,
    // setTemplateData,
    // handleSaveTemplate,
    // setFieldsArr,
    // fieldsArr,
    // designData
  } = useTemplateContext();
  const { sqlTemplateId } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    if (!sqlTemplateExplorerData || selectedTemplate.id === sqlTemplateId) return;
    const file = getFolderFileById(sqlTemplateExplorerData, sqlTemplateId);
    if (file) {
      setSelectedTemplate({
        id: file.id,
        name: file.name,
        parentData: file.parentData
      });
      setIsLoading(false);
    } else {
      navigate("../");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sqlTemplateId, sqlTemplateExplorerData]);

  const renderSqlViewer = () => {
    switch (selectedTemplate.parentData) {
      case "rdbms":
      case "postgres":
        return <RdbmsTemplateViewer file={selectedTemplate} />;
      default:
        return (
          <div className="d_flex justify_center align_center h_100">
            <ErrorMessage>Unsupported template type: {selectedTemplate.parentData}</ErrorMessage>
          </div>
        );
    }
  };

  return (
    <div className="w_100">
      {isLoading ? <Loader /> : <div className="content_main_section">{renderSqlViewer()}</div>}
    </div>
  );
};

export default SqlTemplateCenterViewer;
